import { useState } from 'react';

import 'react-dates/initialize';

import { SingleDatePicker } from 'react-dates';

import PropTypes from 'prop-types';

import _ from 'lodash';

import moment from 'moment';

import { useRouter } from 'next/router';

import { ChevronLeft, ChevronRight, ExpandLess } from '@mui/icons-material';

import Accordion from '@mui/material/Accordion';

import AccordionSummary from '@mui/material/AccordionSummary';

import AccordionDetails from '@mui/material/AccordionDetails';

import useResponsive from '../../../../utils/responsive';

import VerticalDateRangePicker from '../../shared/vertical-date-range-picker.component';

import { Label, Button, NumberSpinner } from '../../shared';

import WaitingListDialog from '../../waiting-list-dialog/waiting-list-dialog.component';

import localStorageService from '../../../services/storage-service/local-storage.service';

const renewalDurations = ['', 'monthly', 'daily'];

const RenewalDuration = Object.freeze({ MONTHLY: 1, DAILY: 2 });

const RoomTypeQuote = (props) => {
   
    const { isMobile, isTablet } = useResponsive();
    const [expanded, setExpanded] = useState(false);
    const [checkAvailabilityText, setCheckAvailabilityText] = useState(false);
    const {
        selectedRoomType,
        preBookingQuote,
        peachRedirect,
        preBookingIsLoading,
        roomTypesIsLoading,
    } = props;
    const [datePickerMoveInFocused, setDatePickerMoveInFocused] = useState(false);
    const [numberOfOccupants, setNumberOfOccupants] = useState(
        _.get(selectedRoomType, 'minGuests'),
    );
    const [preBookingError, setPreBookingError] = useState(null);
    const [preBookingErrorStatus, setPreBookingErrorStatus] = useState(null);
    const [isLoadingQuote, setIsLoadingQuote] = useState(false);    
    
    const [isWaitingListDialogOpen, setIsWaitingListDialogOpen] = useState(false);
    const numberAvailable = _.get(selectedRoomType, 'numberAvailable');
    const router = useRouter();
    const labelText = numberAvailable > 0 ? `only ${numberAvailable} left` : 'Waiting List';
    const labelType = numberAvailable > 0 ? '' : 'green';

    let isAvailable = true;
    const numberAvailableForMales = _.get(selectedRoomType, 'numberAvailableForMales');
    const numberAvailableForFemales = _.get(selectedRoomType, 'numberAvailableForFemales');

    const gender = _.get(router, 'query.gender');
    const startDate = _.get(router, 'query.startDate');
    const endDate = _.get(router, 'query.endDate');
    const roomTypeId = _.get(router, 'query.roomTypeId');
    const roomTypeDescription = _.get(router, 'query.roomTypeDescription');
    const renewalDuration = _.get(selectedRoomType, 'renewalDuration');
    const soonestAvailable = _.get(selectedRoomType, 'soonestAvailable');
    const acceptingProvisionalBookings = _.get(selectedRoomType, 'acceptingProvisionalBookings');
    const [moveInDate, setMoveInDate] = useState(moment(soonestAvailable));
    const [moveOutDate, setMoveOutDate] = useState(
        renewalDuration === RenewalDuration.MONTHLY
            ? moment(soonestAvailable).add(2, 'months').startOf('month').format('YYYY-MM-DD')
            : moment(endDate),
    );
    const isConfiguredForAdditionalChargePerOccupant = _.get(
        selectedRoomType,
        'isConfiguredForAdditionalChargePerOccupant',
    );
    const HOMII_QUOTE_PARAMS = 'homii-quote-params';

    if (
        (numberAvailableForMales === 0 && gender === 'male') ||
        (numberAvailableForFemales === 0 && gender === 'female') ||
        numberAvailable === 0
    ) {
        isAvailable = false;
    }

    if (roomTypesIsLoading) {
        return null;
    }

    const handleExpansionChange = () => {
        setExpanded(!expanded);
    };

    const getQuote = async () => {
        localStorageService.removeItem(HOMII_QUOTE_PARAMS);
        const numberOfOccupantsToSend =
            isConfiguredForAdditionalChargePerOccupant &&
            numberOfOccupants ? "1" : "0";
        const _startDate = moment(moveInDate).format('YYYY-MM-DD');
        const _endDate = moment(moveOutDate).format('YYYY-MM-DD');
        localStorageService.setItem(HOMII_QUOTE_PARAMS, {
            roomTypeId: roomTypeId,
            roomTypeDescription: roomTypeDescription,
            startDate: _startDate,
            endDate: _endDate,
            occupantsToSend: numberOfOccupantsToSend,
            occupants: numberOfOccupants,
            gender: gender
        });
        router.push(
           `/process/authentication/0?roomTypeId=${roomTypeId}&roomTypeDescription=${roomTypeDescription}&startDate=${_startDate}&endDate=${_endDate}&occupantsToSend=${numberOfOccupantsToSend}&occupants=${numberOfOccupants}&gender=${gender}`,
        ); 
    };

    const checkIsAcceptingProvisionalBooking = () => {
        return (
            acceptingProvisionalBookings &&
            moment(soonestAvailable)
                .startOf('day')
                .isAfter(moment().add(1, 'month').startOf('month').startOf('day').add(-1, 'day'))
        );
    };

    const onGetQuoteClick = async () => {
        if (!preBookingQuote || (!peachRedirect && isAvailable)) {
            setIsLoadingQuote(true);
            await getQuote();
        }
    };

    const onContinueClick = async () => {
        setExpanded(true);
    };

    const onJoinWaitingListClick = async () => {
        setIsWaitingListDialogOpen(true);
    };

    const QuoteHeader = () => {
        const roomName = _.get(selectedRoomType, 'description');

        let arrangementType;
        if (_.get(selectedRoomType, 'privateBedroom')) {
            if (_.get(selectedRoomType, 'sharedLivingSpace')) {
                arrangementType = 'Private Room';
            } else if (!_.get(selectedRoomType, 'sharedLivingSpace')) {
                arrangementType = 'Private Apartment';
            }
        } else if (!_.get(selectedRoomType, 'privateBedroom')) {
            arrangementType = `Shared - ${gender}`;
        }

        let livingArrangement = _.get(selectedRoomType, 'privateBedroom')
            ? 'Private'
            : 'Shared living space with shared bedroom';
        if (_.get(selectedRoomType, 'privateBedroom')) {
            livingArrangement = _.get(selectedRoomType, 'sharedLivingSpace')
                ? 'Shared living space with private bedroom'
                : 'Private apartment';
        }
        const mobileQuote = isMobile || isTablet;
        return (
            <>
                <div className='room-type-quote-label-container'>
                    {numberAvailable <= 2 && (expanded || !mobileQuote) && (
                        <Label type={labelType}>{labelText}</Label>
                    )}
                    {gender && (expanded || !mobileQuote) && (
                        <Label type="white">{arrangementType}</Label>
                    )}
                </div>

                <h5 className='room-type-quote-room-name'>{roomName}</h5>

                <h6 className='room-type-quote-city-text'>
                    {_.get(selectedRoomType, 'buildingAddress.addressLine2')}
                </h6>

                <p className='room-type-quote-living-arrangement-text'>
                    {livingArrangement} • Sleeps {_.get(selectedRoomType, 'maxGuests')}
                </p>

            </>
        );
    };

    const onNumberOfOccupantsChange = (guests) => {        
        setNumberOfOccupants(guests);
    };

    const renderNumberOfGuestsInput = () => {
        if (!isConfiguredForAdditionalChargePerOccupant || !isAvailable) {
            return null;
        }
        const maxGuests = _.get(selectedRoomType, 'maxGuests');
        const minGuests = _.get(selectedRoomType, 'minGuests');

        return (
            <>
                <div className='room-type-quote-input-container'>
                    <h6 className='room-type-quote-bold-caption'>No. of Guests</h6>
                    <NumberSpinner
                        min={minGuests}
                        max={maxGuests}
                        value={numberOfOccupants}
                        onChange={onNumberOfOccupantsChange}
                    />
                </div>
                 <hr className='room-type-quote-divider' />
            </>
        );
    };

    const isOutsideRange = (date) => {
        return (
            moment(date) < moment(soonestAvailable) ||
            moment(date) > moment(soonestAvailable).add(1, 'months').startOf('month').add(1, 'day')
        );
    };

    const isOutsideRangeDaily = (date) => {
        return moment(date).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD');
    };

    const onMoveInDateChange = (date) => {
        setMoveInDate(date);
    };

    const onDateRangeChange = (start, end) => {
        setMoveInDate(start);
        setMoveOutDate(end);
        if (start !== startDate || end !== endDate) {
            setCheckAvailabilityText(true);
        } else {
            setCheckAvailabilityText(false);
        }
        setPreBookingErrorStatus(null);
        setPreBookingError(null);
    };

    const renderDateInput = () => {
        if (!isAvailable) {
            return null;
        }

        if (
            moment(soonestAvailable)
                .startOf('day')
                .isSame(moment().add(1, 'months').startOf('month').startOf('day')) ||
            checkIsAcceptingProvisionalBooking()
        ) {
            return (
                <>
                    <div className='room-type-quote-input-container'>
                        <h6 className='room-type-quote-bold-caption'>Move in Date</h6>
                        <p className='room-type-quote-date-text'>{moment(soonestAvailable).format('D MMM')}</p>
                    </div>

                     <hr className='room-type-quote-divider' />
                </>
            );
        }

        if (renewalDuration === RenewalDuration.DAILY && startDate) {
            return (
                <>
                    <h6 className='room-type-quote-bold-caption' style={{ bottom: 20 }}>Move in - Move out</h6>
                    <VerticalDateRangePicker
                        startDate={moveInDate}
                        endDate={moveOutDate}
                        onDateRangeChange={onDateRangeChange}
                        dateFormat="DD MMM"
                        hasInput
                        isOutsideRange={isOutsideRangeDaily}
                    />

                    <hr className='room-type-quote-divider' style={{ top: 35 }} />                    
                </>
            );
        }

        return (
            <>
                <div className='room-type-quote-input-container' style={{ bottom: 20}}>
                    <h6 className='room-type-quote-bold-caption'>Move in Date</h6>
                    <div id="room-type-quote-date-picker" className='room-type-quote-date-picker-container'>
                        <SingleDatePicker
                            date={moveInDate}
                            onDateChange={onMoveInDateChange}
                            focused={datePickerMoveInFocused}
                            displayFormat="D MMMM"
                            onFocusChange={({ focused }) => {
                                setDatePickerMoveInFocused(focused);
                                document.activeElement.blur();
                            }}
                            id="move-in-date-selector"
                            numberOfMonths={1}
                            anchorDirection="right"
                            hideKeyboardShortcutsPanel
                            // minDate & maxDate not currently supported in 21.8.0 see:
                            // https://github.com/airbnb/react-dates/issues/1997
                            enableOutsideDays={false}
                            navPrev={<ChevronLeft className='room-type-quote-prev-button' />}
                            navNext={<ChevronRight className='room-type-quote-next-button' />}
                            calendarInfoPosition="bottom"
                            isOutsideRange={isOutsideRange}
                        />
                    </div>
                </div>

                 <hr className='room-type-quote-divider' />
            </>
        );
    };

    const renderDiscount = () => {
        if (!preBookingQuote || !preBookingQuote.discountAmount || !isAvailable) {
            return null;
        }
        const { discountPercentage } = preBookingQuote;

        return (
            <>
                <div className='room-type-quote-discount-container'>
                    <h6 className='room-type-quote-bold-caption'>Discount</h6>
                    <p>{discountPercentage}% off room price</p>
                </div>

               <hr className='room-type-quote-divider' />
            </>
        );
    };

    const renderMonthlyAmount = () => {
        const startingPrice = _.get(selectedRoomType, 'startingPrice');

        return (
            <h5>
                R
                {!checkIsAcceptingProvisionalBooking()
                    ? startingPrice
                    : _.get(preBookingQuote, 'amount')}{' '}
                {!checkIsAcceptingProvisionalBooking() ? 'per month' : 'deposit'}
            </h5>
        );
    };

    const renderDailyAmounts = () => {
        const startingPrice = _.get(selectedRoomType, 'startingPrice');

        return <h5>R{startingPrice} Per Day</h5>;
    };

    const renderQuoteAmounts = () => {
        if ((checkIsAcceptingProvisionalBooking() && !preBookingQuote) || !isAvailable) {
            return null;
        }
        const billingModelDescription = _.get(selectedRoomType, 'billingModelDescription');
        return (
            <div className='room-type-quote-container'>
                {renewalDurations[renewalDuration] === renewalDurations[1] &&
                    !checkIsAcceptingProvisionalBooking() && <h6>{billingModelDescription}</h6>}
                <div className='room-type-quote-amounts-container'>
                    {renewalDurations[renewalDuration] === renewalDurations[1]
                        ? renderMonthlyAmount()
                        : renderDailyAmounts()}
                </div>
            </div>
        );
    };

    const renderMobileQuoteAmounts = () => {
        if ((checkIsAcceptingProvisionalBooking() && !preBookingQuote) || !isAvailable) {
            return null;
        }
        const billingModelDescription = _.get(selectedRoomType, 'billingModelDescription');
        return (
            <div className='room-type-quote-mobile-quote-container'>
                {renewalDurations[renewalDuration] === renewalDurations[1] &&
                    !checkIsAcceptingProvisionalBooking() && <h6>{billingModelDescription}</h6>}
                {renewalDurations[renewalDuration] === renewalDurations[1]
                    ? renderMonthlyAmount()
                    : renderDailyAmounts()}
            </div>
        );
    };

    const QuoteButtons = () => {
        let buttonText = checkAvailabilityText ? 'Check Availability' : 'Book Now';
        if ((isMobile || isTablet) && !expanded) {
            buttonText = 'Continue';
        }
        if (checkIsAcceptingProvisionalBooking()) {
            buttonText = 'Book Now';
        }
        if (
            !isAvailable ||
            (preBookingErrorStatus === 404 &&
                renewalDuration === RenewalDuration.DAILY &&
                checkAvailabilityText)
        ) {
            return null;
        }

        return (
            <div className='room-type-quote-input-container'>
                <Button                  
                    id="book-now-quote-button"
                    onClick={
                        (isMobile || isTablet) && !expanded ? onContinueClick : onGetQuoteClick
                    }
                    isLoading={isLoadingQuote && preBookingIsLoading}
                >
                    {buttonText}
                </Button>
            </div>
        );
    };

    const WaitingListButton = () => {
        if (isAvailable && renewalDuration === RenewalDuration.MONTHLY) {
            return null;
        }
        if (
            preBookingErrorStatus !== 404 &&
            renewalDuration === RenewalDuration.DAILY &&
            isAvailable
        ) {
            return null;
        }

        return (
            <div className='room-type-quote-input-container'>
                <Button
                    id="waiting-list-button"
                    onClick={onJoinWaitingListClick}
                >
                    Join Waiting List
                </Button>
            </div>
        );
    };

    const renderDetailsPanel = () => {
        return (
            <>
                {renderNumberOfGuestsInput()}
                {renderDateInput()}
                {renderDiscount()}
            </>
        );
    };

    const mobileQuote = isMobile || isTablet;

    return (
        <>
            {mobileQuote && (

                <div id="mobile-quote-container" className='room-type-quote-mobile-container' style={{ paddingTop: expanded ? 20 : 0 }} expanded={expanded}>

                    <QuoteHeader />

                    <Accordion
                        className='room-type-quote-accordion'
                        expanded={expanded}
                        onChange={handleExpansionChange}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandLess />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            className={
                                // eslint-disable-next-line no-nested-ternary
                                labelText === 'Waiting List'
                                    ? 'room-type-quote-expansion-summary-waiting-list'
                                    : isConfiguredForAdditionalChargePerOccupant
                                    ? 'room-type-quote-expansion-summary-number-of-guest'
                                    : 'room-type-quote-expansion-summary'
                            }
                        />

                        <AccordionDetails className='room-type-quote-panel-details'>
                            {renewalDuration === RenewalDuration.DAILY && startDate && (
                                <div className='room-type-quote-mobile-scroll'>{renderDetailsPanel()}</div>
                            )}
                            {renewalDuration !== RenewalDuration.DAILY && renderDetailsPanel()}
                        </AccordionDetails>

                    </Accordion>

                    {renderMobileQuoteAmounts()}

                    <p className='room-type-quote-error-message'>{preBookingError}</p>
                    
                    <QuoteButtons />

                    <WaitingListButton />

                </div>
            )}

            {!mobileQuote && (

                <div className='room-type-quote-card' id="booking-quote-container">

                    <QuoteHeader />

                    <hr className='room-type-quote-divider' />

                    {renderDateInput()}

                    {renderNumberOfGuestsInput()}

                    {renderDiscount()}

                    {renderQuoteAmounts()}

                    <p className='room-type-quote-error-message'>{preBookingError}</p>

                    <QuoteButtons />

                    <WaitingListButton />

                </div>
            )}

            <WaitingListDialog
                isOpen={isWaitingListDialogOpen}
                setIsOpen={setIsWaitingListDialogOpen}
            />

        </>
    );
};

export default RoomTypeQuote;

RoomTypeQuote.propTypes = {
    selectedRoomType: PropTypes.object,
    preBookingQuote: PropTypes.object,
    peachRedirect: PropTypes.bool,
    preBookingIsLoading: PropTypes.bool,
    roomTypesIsLoading: PropTypes.bool,
};


